<div fxLayout="row">
    <div [innerHTML]="privacyPolicy | sanitizeHtml">
    </div>
</div>